import { Outlet } from 'react-router-dom';

const AdminLayout = () => (
  <main className="main-content">
    <Outlet />
  </main>
);

export default AdminLayout;
